import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { toast } from 'react-toastify';
export const userActions = {
    getAllSport,
    getAllSeries,
    getAllMatch,
    createSport,
    createSeries,
    createMatch,
    getProfile,
    login,
    logout,
    updateUserPasswordSubmit,
    createLead,
    createNewUser,
    updateUser,
    createCategory,
    getUserActive,
    getUserDeactive,
    disableLead,
    disableReminder,
    disableUser,
    deleteLead,
    deleteCategory,
    verifyEmail,
    loginToThisAccount,
    getEmsSlotBookingByUser,
    getMassageSlotBookingByUserId,
    getGroupClassSlotBookingByUserId,
    getTrainerSlotBookingByUserId,
    getUserProfile,
    getAllMatchActive,
    updateMatchStatus,
    uploadImage,
    updateMatchMarketId,
    getOdds,
    getMatchBymatchId,
    updateMatchTeamImage,
    AddUserBalance,
    deductUserBalance,
    uploadVideo,
    getLeadById,
    getTxListByUser,
    getFollowUpListByLeadId,
    getLoginHistoryListByUserId,
    getLeadList,
    getReminderList,
    getAllCategory,
    getAllUser,
    getCategoryList,
    disableTicket,
    deleteTicket,
    approveTicket,
    getUserList,
    updateLead,
    updateCategory,
    updateCategoryStatus,
    updateUserpassword,
    uploadImageClear,
    getUserListIsDisable,
    createFollowUp,
    createFollowUpReminder,
    createFollowUpLead,
    changePassword
};

function uploadImageClear() {
    return dispatch => {
        dispatch(success());
    };
    function success(uploadImage) { return { type: userConstants.FILE_UPLOAD_CLEAR_SUCCESS, uploadImage } }
}

function changePassword(data, paginationData) {
    // let reqData = {
    //     "keyWord": "",
    //     "pageNo": 1,
    //     "size": 10
    // }
    return dispatch => {
        dispatch(request());
        userService.changePassword(data)
            .then(

                users => {
                    // toast("Password Updated successfully.")
                    dispatch(alertActions.success("Password Updated successfully."));
                    dispatch(success(users));
                    // dispatch(this.getUserActive(paginationData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_USER_PASSWORD_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_USER_PASSWORD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_USER_PASSWORD_FAILURE, error } }
}



function createCategory(data) {
    let reqData = {
        "keyWord": "",
        "pageNo": 1,
        "size": 10
    }
    return dispatch => {
        dispatch(request());
        userService.createCategory(data)
            .then(

                users => {
                    dispatch(alertActions.success("Category Add Successfully."));
                    dispatch(success(users));
                    dispatch(this.getCategoryList(reqData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.ADD_CATEGORY_REQUEST } }
    function success(users) { return { type: userConstants.ADD_CATEGORY_SUCCESS, users } }
    function failure(error) { return { type: userConstants.ADD_CATEGORY_FAILURE, error } }
}

function updateCategory(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.updateCategory(data)
            .then(
                users => {
                    dispatch(alertActions.success("Category Updated Successfully."));
                    dispatch(success(users))
                    dispatch(this.getCategoryList(tempData))
                    // dispatch(this.uploadImageClear());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_CATEGORY_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_CATEGORY_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_CATEGORY_FAILURE, error } }
}

function getCategoryList(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.getCategoryList(data)
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_CATEGORY_LIST_REQUEST } }
    function success(users) { return { type: userConstants.GET_CATEGORY_LIST_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_CATEGORY_LIST_FAILURE, error } }
}

function updateCategoryStatus(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.updateCategoryStatus(data)
            .then(
                users => {
                    dispatch(alertActions.success("Category Status Successfully Changed."));
                    dispatch(success(users))
                    dispatch(this.getCategoryList(tempData))
                    // dispatch(this.uploadImageClear());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_CATEGORY_STATUS_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_CATEGORY_STATUS_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_CATEGORY_STATUS_FAILURE, error } }
}

function createFollowUp(data, followUpReqData) {
    return dispatch => {
        dispatch(request());
        userService.createFollowUp(data)
            .then(
                users => {
                    dispatch(alertActions.success("Follow Up Updated Successfully."));
                    dispatch(success(users))
                    dispatch(this.getFollowUpListByLeadId(followUpReqData))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_FOLLOW_UP_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_FOLLOW_UP_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_FOLLOW_UP_FAILURE, error } }
}

function createFollowUpLead(data, followUpReqData) {
    return dispatch => {
        dispatch(request());
        userService.createFollowUp(data)
            .then(
                users => {
                    dispatch(alertActions.success("Follow Up Updated Successfully."));
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_FOLLOW_UP_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_FOLLOW_UP_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_FOLLOW_UP_FAILURE, error } }
}

function createFollowUpReminder(data, remiderData) {
    return dispatch => {
        dispatch(request());
        userService.createFollowUp(data)
            .then(
                users => {
                    dispatch(alertActions.success("Follow Up Updated Successfully."));
                    dispatch(success(users))
                    dispatch(this.getReminderList(remiderData))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_FOLLOW_UP_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_FOLLOW_UP_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_FOLLOW_UP_FAILURE, error } }
}

function updateLead(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.updateLead(data)
            .then(
                users => {
                    dispatch(alertActions.success("Lead Updated Successfully."));
                    dispatch(success(users))
                    dispatch(this.getLeadList(tempData))
                    dispatch(this.uploadImageClear());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_LEAD_FAILURE, error } }
}


function getUserList(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.getUserList(data)
            .then(
                users => {

                    console.log("getUserListgetUserList", users);
                    dispatch(success(users))
                    // dispatch(success(uploadImage));
                    // dispatch(this.uploadImageClear());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_USER_LIST_REQUEST } }
    function success(users) { return { type: userConstants.GET_USER_LIST_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_USER_LIST_FAILURE, error } }
} console.log();



function getLeadList(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.getLeadList(data)
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_LEAD_LIST_REQUEST } }
    function success(users) { return { type: userConstants.GET_LEAD_LIST_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_LEAD_LIST_FAILURE, error } }
}

function getReminderList(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.getReminderList(data)
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_REMAINDER_LIST_REQUEST } }
    function success(users) { return { type: userConstants.GET_REMAINDER_LIST_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_REMAINDER_LIST_FAILURE, error } }
}

function getAllUser() {
    return dispatch => {
        dispatch(request());
        userService.getAllUser()
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_ALL_USER_REQUEST } }
    function success(users) { return { type: userConstants.GET_ALL_USER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_ALL_USER_FAILURE, error } }
}

function getAllCategory() {
    return dispatch => {
        dispatch(request());
        userService.getAllCategory()
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_ALL_CATEGORY_REQUEST } }
    function success(users) { return { type: userConstants.GET_ALL_CATEGORY_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_ALL_CATEGORY_FAILURE, error } }
}

function deleteTicket(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.deleteTicket(data)
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DELETE_TICKET_REQUEST } }
    function success(users) { return { type: userConstants.DELETE_TICKET_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DELETE_TICKET_FAILURE, error } }
}
function disableTicket(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.disableTicket(data)
            .then(
                users => {
                    dispatch(success(users))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DISABLE_TICKET_REQUEST } }
    function success(users) { return { type: userConstants.DISABLE_TICKET_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DISABLE_TICKET_FAILURE, error } }
}
function approveTicket(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.approveTicket(data)
            .then(
                users => {
                    dispatch(success(users))
                    dispatch(this.getLeadList(tempData))

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.APPROVE_TICKET_REQUEST } }
    function success(users) { return { type: userConstants.APPROVE_TICKET_SUCCESS, users } }
    function failure(error) { return { type: userConstants.APPROVE_TICKET_FAILURE, error } }
}

// function createMarket(data, tempData) {
//     return dispatch => {
//         dispatch(request());
//         userService.deductUserBalance(data)
//             .then(
//                 users => {
//                     dispatch(success(users))
//                     dispatch(alertActions.success("Deduct your balance Successfully."));
//                     // dispatch(this.getAllMarket(data));
//                 },
//                 error => {
//                     dispatch(alertActions.error(error));
//                     dispatch(failure(error))
//                 }
//             );
//     };
//     function request() { return { type: userConstants.DEDUCT_BALANCE_REQUEST } }
//     function success(users) { return { type: userConstants.DEDUCT_BALANCE_SUCCESS, users } }
//     function failure(error) { return { type: userConstants.DEDUCT_BALANCE_FAILURE, error } }
// }
function AddUserBalance(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.AddUserBalance(data)
            .then(
                users => {
                    dispatch(success(users))
                    dispatch(alertActions.success("Add your balance Successfully."));
                    // dispatch(this.getUserList(tempData));
                    dispatch(this.getUserList(tempData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.CREATE_BALANCE_REQUEST } }
    function success(users) { return { type: userConstants.CREATE_BALANCE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.CREATE_BALANCE_FAILURE, error } }
}
function deductUserBalance(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.deductUserBalance(data)
            .then(
                users => {
                    dispatch(success(users))
                    dispatch(alertActions.success("Deduct User Balance Successfully."));
                    dispatch(this.getUserList(tempData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DEDUCT_BALANCE_REQUEST } }
    function success(users) { return { type: userConstants.DEDUCT_BALANCE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DEDUCT_BALANCE_FAILURE, error } }
}

function createMatch(data, tempData) {
    console.log("tempData:::", tempData);
    return dispatch => {
        dispatch(request());
        userService.createMatch(data)
            .then(
                users => {
                    dispatch(success(users))
                    dispatch(this.getAllMatch(tempData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.ADD_MATCH_REQUEST } }
    function success(users) { return { type: userConstants.ADD_MATCH_SUCCESS, users } }
    function failure(error) { return { type: userConstants.ADD_MATCH_FAILURE, error } }
}
function updateMatchMarketId(data, tempData) {
    return dispatch => {
        dispatch(request());
        userService.updateMatchMarketId(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(this.getAllMatch(tempData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_MATCH_MARKET_ID_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_MATCH_MARKET_ID_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_MATCH_MARKET_ID_FAILURE, error } }
}

function uploadImage(data) {
    return dispatch => {
        dispatch(request());
        userService.uploadImage(data)
            .then(
                uploadImage => {
                    toast("Image Uploaded successfully.")
                    dispatch(success(uploadImage));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.FILE_UPLOAD_STATUS_REQUEST } }
    function success(uploadImage) { return { type: userConstants.FILE_UPLOAD_STATUS_SUCCESS, uploadImage } }
    function failure(error) { return { type: userConstants.FILE_UPLOAD_STATUS_FAILURE, error } }

}

function uploadVideo(data) {
    return dispatch => {
        dispatch(request());
        userService.uploadVideo(data)
            .then(
                uploadImage => {
                    toast("Video Uploaded successfully.")
                    dispatch(success(uploadImage));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.FILE_UPLOAD_STATUS_VIDEO_REQUEST } }
    function success(uploadImage) { return { type: userConstants.FILE_UPLOAD_STATUS_VIDEO_SUCCESS, uploadImage } }
    function failure(error) { return { type: userConstants.FILE_UPLOAD_STATUS_VIDEO_FAILURE, error } }

}

function createSeries(data) {
    return dispatch => {
        dispatch(request());
        userService.createSeries(data)
            .then(
                users => {
                    dispatch(success(users))
                    dispatch(this.getAllSeries(data.sportId));
                },
                error => {
                    dispatch(alertActions.error(error));

                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.ADD_SERIES_REQUEST } }
    function success(users) { return { type: userConstants.ADD_SERIES_SUCCESS, users } }
    function failure(error) { return { type: userConstants.ADD_SERIES_FAILURE, error } }
}
function updateMatchStatus(data) {
    console.log("statusmatch::", data);
    return dispatch => {
        dispatch(request());
        userService.updateMatchStatus(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(this.getAllMatchActive());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_MATCH_STATUS_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_MATCH_STATUS_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_MATCH_STATUS_FAILURE, error } }
}


function updateUserpassword(data, paginationData) {
    console.log("statusmatch::", data);
    return dispatch => {
        dispatch(request());
        userService.updateUserpassword(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(this.getUserList(paginationData));
                    dispatch(alertActions.success('password update successfully'))
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_USERS_PASSWORD_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_USERS_PASSWORD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_USERS_PASSWORD_FAILURE, error } }
}

function createSport(data) {
    return dispatch => {
        dispatch(request());
        userService.createSport(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.ADD_SPORT_REQUEST } }
    function success(users) { return { type: userConstants.ADD_SPORT_SUCCESS, users } }
    function failure(error) { return { type: userConstants.ADD_SPORT_FAILURE, error } }
}

function getUserProfile(data) {
    return dispatch => {
        dispatch(request());
        userService.getUserProfile(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_PROFILE_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_PROFILE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_PROFILE_FAILURE, error } }
}

function getTxListByUser(data) {
    return dispatch => {
        dispatch(request());
        userService.getTxListByUser(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_TX_LIST_BY_USER_REQUEST } }
    function success(users) { return { type: userConstants.GET_TX_LIST_BY_USER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_TX_LIST_BY_USER_FAILURE, error } }
}
function getLeadById(data) {
    return dispatch => {
        dispatch(request());
        userService.getLeadById(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_LEAD_BY_ID_REQUEST } }
    function success(users) { return { type: userConstants.GET_LEAD_BY_ID_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_LEAD_BY_ID_FAILURE, error } }
}
function getFollowUpListByLeadId(data) {
    return dispatch => {
        dispatch(request());
        userService.getFollowUpListByLeadId(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_FOLLOW_UP_LIST_BY_LEAD_ID_REQUEST } }
    function success(users) { return { type: userConstants.GET_FOLLOW_UP_LIST_BY_LEAD_ID_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_FOLLOW_UP_LIST_BY_LEAD_ID_FAILURE, error } }
}
function getLoginHistoryListByUserId(data) {
    return dispatch => {
        dispatch(request());
        userService.getLoginHistoryListByUserId(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_LOGIN_HISTORY_REQUEST } }
    function success(users) { return { type: userConstants.GET_LOGIN_HISTORY_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_LOGIN_HISTORY_FAILURE, error } }
}

function getEmsSlotBookingByUser(data) {
    return dispatch => {
        dispatch(request());
        userService.getEmsSlotBookingByUser(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_EMS_SLOT_BOOKING_REQUEST } }
    function success(users) { return { type: userConstants.GET_EMS_SLOT_BOOKING_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_EMS_SLOT_BOOKING_FAILURE, error } }
}

function getMassageSlotBookingByUserId(data) {
    return dispatch => {
        dispatch(request());
        userService.getMassageSlotBookingByUserId(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_MASSAGE_SLOT_BOOKING_REQUEST } }
    function success(users) { return { type: userConstants.GET_MASSAGE_SLOT_BOOKING_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_MASSAGE_SLOT_BOOKING_FAILURE, error } }
}

function getGroupClassSlotBookingByUserId(data) {
    return dispatch => {
        dispatch(request());
        userService.getGroupClassSlotBookingByUserId(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_GROUP_SLOT_BOOKING_REQUEST } }
    function success(users) { return { type: userConstants.GET_GROUP_SLOT_BOOKING_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_GROUP_SLOT_BOOKING_FAILURE, error } }
}

function getTrainerSlotBookingByUserId(data) {
    return dispatch => {
        dispatch(request());
        userService.getTrainerSlotBookingByUserId(data)
            .then(
                users =>
                    // console.log('users_____________11111111__', users),
                    dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_TRAINER_SLOT_BOOKING_REQUEST } }
    function success(users) { return { type: userConstants.GET_TRAINER_SLOT_BOOKING_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_TRAINER_SLOT_BOOKING_FAILURE, error } }
}
function updateMatchTeamImage(data) {
    return dispatch => {
        dispatch(request());
        userService.updateMatchTeamImage(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(this.getAllMatchActive());
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_MATCH_TEAM_IMAGE_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_MATCH_TEAM_IMAGE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_MATCH_TEAM_IMAGE_FAILURE, error } }
}
function getAllMatchActive(data) {
    return dispatch => {
        dispatch(request());
        userService.getAllMatchActive(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_MATCH_ACTIVE_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_MATCH_ACTIVE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_MATCH_ACTIVE_FAILURE, error } }
}
function getAllMatch(data) {
    return dispatch => {
        dispatch(request());
        userService.getAllMatch(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_MATCH_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_MATCH_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_MATCH_FAILURE, error } }
}

function getAllSeries(data) {
    return dispatch => {
        dispatch(request());
        userService.getAllSeries(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_SERIES_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SERIES_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_SERIES_FAILURE, error } }
}
function getOdds(data) {
    return dispatch => {
        // dispatch(request());
        userService.getOdds(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    // function request() { return { type: userConstants.GET_ODDS_REQUEST } }
    function success(users) { return { type: userConstants.GET_ODDS_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_ODDS_FAILURE, error } }
}
function getMatchBymatchId(data) {
    return dispatch => {
        dispatch(request());
        userService.getMatchBymatchId(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_MATCH_BY_MATCHID_REQUEST } }
    function success(users) { return { type: userConstants.GET_MATCH_BY_MATCHID_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_MATCH_BY_MATCHID_FAILURE, error } }
}

function getAllSport(data) {
    return dispatch => {
        dispatch(request());
        userService.getAllSport(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_SPORT_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SPORT_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_SPORT_FAILURE, error } }
}

function login(data, props) {

    console.log("dataACTION:::!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", data);

    return dispatch => {
        dispatch(request({ data }));
        userService.login(data)
            .then(
                user => {
                    dispatch(success(user));
                    props.history.push({ pathname: 'app/dashboard' });
                },
                error => {
                    console.log("errorerror ", error);
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.USERS_LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.USERS_LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.USERS_LOGIN_FAILURE, error } }
}
function logout() {
    // userService.logout();
    return { type: userConstants.LOGOUT };
}
function verifyEmail(data, paginationData) {

    return dispatch => {
        dispatch(request());
        userService.verifyEmail(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(this.getUserActive(paginationData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.USER_VERIFY_EMAIL_REQUEST } }
    function success(users) { return { type: userConstants.USER_VERIFY_EMAIL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.USER_VERIFY_EMAIL_FAILURE, error } }
}
function deleteLead(data, paginationFilter) {

    return dispatch => {
        dispatch(request());
        userService.deleteLead(data)
            .then(
                users => {
                    dispatch(alertActions.success("Lead Deleted Successfully."));
                    dispatch(success(users));
                    dispatch(this.getLeadList(paginationFilter));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DELETE_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.DELETE_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DELETE_LEAD_FAILURE, error } }
}
function deleteCategory(data, paginationData) {

    return dispatch => {
        dispatch(request());
        userService.deleteCategory(data)
            .then(
                users => {
                    dispatch(alertActions.success("Category Deleted Successfully."));
                    dispatch(success(users));
                    dispatch(this.getCategoryList(paginationData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DELETE_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.DELETE_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DELETE_LEAD_FAILURE, error } }
}

function disableLead(data, paginationData) {
    return dispatch => {
        dispatch(request());
        userService.disableLead(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(alertActions.success("Lead Status Update Successfully."));
                    dispatch(this.getLeadList(paginationData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DISABLE_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.DISABLE_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DISABLE_LEAD_FAILURE, error } }
}

function disableReminder(data, paginationData) {

    return dispatch => {
        dispatch(request());
        userService.disableReminder(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(alertActions.success("Reminder Status Update Successfully."));
                    dispatch(this.getReminderList(paginationData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DISABLE_REMINDER_REQUEST } }
    function success(users) { return { type: userConstants.DISABLE_REMINDER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DISABLE_REMINDER_FAILURE, error } }
}

function disableUser(data, paginationData) {

    return dispatch => {
        dispatch(request());
        userService.disableUser(data)
            .then(
                users => {
                    dispatch(success(users));
                    dispatch(alertActions.success("User Status Update Successfully."));
                    dispatch(this.getUserList(paginationData));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.DISABLE_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.DISABLE_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.DISABLE_LEAD_FAILURE, error } }
}
function getUserActive(data) {
    return dispatch => {
        dispatch(request());
        userService.getUserActive(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_USER_ACTIVE_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_USER_ACTIVE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_USER_ACTIVE_FAILURE, error } }
}

function getUserDeactive(data) {
    console.log("data m kya aa rha h::action:::", data);
    return dispatch => {
        dispatch(request());
        userService.getUserDeactive(data)
            .then(
                users => dispatch(success(users)),
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GETALL_USER_DEACTIVE_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_USER_DEACTIVE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_USER_DEACTIVE_FAILURE, error } }
}

function createLead(data,multiselectRef, multiselectRefUser) {
    let reqData = {
        "keyWord": "",
        "pageNo": 1,
        "size": 12,
        "status": "NEW"
    }
    return dispatch => {
        dispatch(request());
        userService.createLead(data)
            .then(

                users => {
                    // toast("Password Updated successfully.")
                    dispatch(alertActions.success("Lead Add Successfully."));
                    dispatch(success(users));
                    dispatch(this.getLeadList(reqData));
                    multiselectRef.current.resetSelectedValues();
                    multiselectRefUser.current.resetSelectedValues();

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.ADD_LEAD_REQUEST } }
    function success(users) { return { type: userConstants.ADD_LEAD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.ADD_LEAD_FAILURE, error } }
}

function createNewUser(data, pagination) {

    return dispatch => {
        dispatch(request());
        userService.createNewUser(data)
            .then(

                users => {
                    // toast("Password Updated successfully.")
                    dispatch(alertActions.success("User Add Successfully."));
                    dispatch(success(users));
                    dispatch(this.getUserList(pagination));
                    // dispatch(this.getLeadList(reqData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.CREATE_USER_REQUEST } }
    function success(users) { return { type: userConstants.CREATE_USER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.CREATE_USER_FAILURE, error } }
}

function updateUser(data, pagination) {

    return dispatch => {
        dispatch(request());
        userService.updateUser(data)
            .then(

                users => {
                    // toast("Password Updated successfully.")
                    dispatch(alertActions.success("User Update Successfully."));
                    dispatch(success(users));
                    dispatch(this.getUserList(pagination));
                    // dispatch(this.getLeadList(reqData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_USER_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_USER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_USER_FAILURE, error } }
}

function updateUserPasswordSubmit(data, paginationData) {
    // let reqData = {
    //     "keyWord": "",
    //     "pageNo": 1,
    //     "size": 10
    // }
    return dispatch => {
        dispatch(request());
        userService.updateUserPasswordSubmit(data)
            .then(

                users => {
                    // toast("Password Updated successfully.")
                    dispatch(alertActions.success("Password Updated successfully."));
                    dispatch(success(users));
                    dispatch(this.getUserActive(paginationData));

                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.UPDATE_USER_PASSWORD_REQUEST } }
    function success(users) { return { type: userConstants.UPDATE_USER_PASSWORD_SUCCESS, users } }
    function failure(error) { return { type: userConstants.UPDATE_USER_PASSWORD_FAILURE, error } }
}

function loginToThisAccount(data) {
    // console.log("data m kya aa rha h::action:::", data);
    return dispatch => {
        dispatch(request());
        userService.loginToThisAccount(data)
            .then(
                users => {
                    console.log("$$$$$$$$$$$ loginToThisAccount $$$$ action:", users);
                    dispatch(success(users));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.LOGIN_TO_THIS_ACCOUNT_REQUEST } }
    function success(users) { return { type: userConstants.LOGIN_TO_THIS_ACCOUNT_SUCCESS, users } }
    function failure(error) { return { type: userConstants.LOGIN_TO_THIS_ACCOUNT_FAILURE, error } }
}

function getProfile(data) {
    // console.log("data m kya aa rha h::action:::", data);
    return dispatch => {
        dispatch(request());
        userService.getProfile(data)
            .then(
                users => {
                    // console.log("$$$$$$$$$$$ getProfile $$$$ action:", users);
                    dispatch(success(users));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_PROFILE_REQUEST } }
    function success(users) { return { type: userConstants.GET_PROFILE_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_PROFILE_FAILURE, error } }
}
function getUserListIsDisable(data) {
    // console.log("data m kya aa rha h::action:::", data);
    return dispatch => {
        dispatch(request());
        userService.getUserListIsDisable(data)
            .then(
                users => {
                    // console.log("$$$$$$$$$$$ getProfile $$$$ action:", users);
                    dispatch(success(users));
                },
                error => {
                    dispatch(alertActions.error(error));
                    dispatch(failure(error))
                }
            );
    };
    function request() { return { type: userConstants.GET_DEACTIVE_USER_REQUEST } }
    function success(users) { return { type: userConstants.GET_DEACTIVE_USER_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GET_DEACTIVE_USER_FAILURE, error } }
}

